import React from 'react';
import { useFormContext } from 'react-hook-form';

export const Errors = () => {
    const { formState } = useFormContext();
    const keys = Object.keys(formState.errors);
    if (keys.length < 1) return null;

    if (keys.length > 1) return <p className='tw-text-red-600'>Details are required.</p>;

    return <p className='tw-text-red-600'>{formState.errors[keys[0]].message}</p>;
};
